import React, { useEffect, useState } from 'react';
import {
  TitleRow,
  ContainerRow,
  AddButton,
  SearchInputStyle,
  ControlsDiV
} from '../styledComponents';
import { StyledListTab } from './styledComponents.js';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { useSelector } from 'react-redux';
import TanStackUserTable from '../../CustomComponents/TanStackUserTable';
import { createReviewerColumns } from './tanstackColumnConfig';
import { getReviewers } from '../../../Apis/User';
import {
  listAll,
  editReviewer,
  saveReviewer,
  saveReviewerGroup,
  editReviewerGroup,
  listAllGroups
} from '../../../Apis/Reviewer';
import { StyledJobListTabPane } from '../JobList/styledComponents.js';
import {
  RESULTS_PER_PAGE,
  SEARCH_DELAY
} from '../../../Constants/StringConstants';
import { PlusOutlined, SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';
import { exportToExcel } from '../../../Utils/ExcelExport';
// import AddReviewerForm from './AddReviewerForm.jsx';
import AddReviewerForm from './AddReviewerForm.jsx';
import AddReviewerGroupForm from './AddReviewerGroupForm.jsx';
import PageTitle from '../../../Utils/PageTitle';
import { useDebounce } from '../../../Utils/Debounce';
import { useCallback } from 'react';
import { reInviteUser } from '../../../Apis/User';

import FacilityFilter from '../../CustomComponents/FacilityFilter';
import { getUserFacilities } from '../../../Apis/User.js';
import { disableOrEnableUser } from '../../../Apis/ClinicAdmin';
import { Tabs } from 'antd'; // Add this import
const { TabPane } = Tabs;
function Reviewers() {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [searchString, setSearchString] = useState('');
  const [total, setTotal] = useState(0);
  const [reviewers, setReviewers] = useState([]);
  const [reviewersList, setReviewersList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [addDrawerVisible, setAddDrawerVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [filterKey, setFilterKey] = useState('name');
  const [sortOrder, setSortOrder] = useState('');
  const [reviewersGroupList, setReviewersGroupList] = useState('');
  const [facilities, setFacilities] = useState([]);
  const [facility, setFacility] = useState([]);
  const [clearFiltersTrigger, setClearFiltersTrigger] = useState(0);
  const userData = useSelector(state => state.userReducer);
  const notClinicAdmin = userData.userType !== 'clinicAdmin' && userData.userType !== 'admin';

  const userId = userData.id;
  const [selectedTabKey, setSelectedTabKey] = useState('reviewer');
  const fetchAll = () => {
    setLoading(true);
    if (selectedTabKey === 'reviewer') {
      // Simplified API call - backend sends all items without pagination params
      listAll()
        .then(response => {
          setLoading(false);
          if (response.data.success) {
            setTotal(response.data.size);
            setReviewers(response.data.result);
          }
        })
        .catch(err => {
          setLoading(false);
        });
    } else {
      // Simplified API call - backend sends all items without pagination params
      listAllGroups()
        .then(response => {
          setLoading(false);
          if (response.data.success) {
            setTotal(response.data.size);
            setReviewersGroupList(response.data.result);
          }
        })
        .catch(err => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line
  }, [selectedTabKey]); // Refetch when switching tabs, facility filtering is done client-side


  const submitHandler = values => {
    setSubmitLoading(true);
    const payload = values;
    values.phoneNumber.number = values.phoneNumber.number.replace(
      values.phoneNumber.countryCode,
      ''
    );
    if (selectedItem) {
      payload.id = selectedItem.id;
      editReviewer(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Updated',
              description: 'Reviewer details updated.'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    } else {
      saveReviewer(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Added',
              description: 'Reviewer added successfully.'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    }
  };
  const submitGroupHandler = values => {
    setSubmitLoading(true);
    values.id = userId;
    const payload = values;

    if (selectedItem) {
      payload.id = selectedItem.id;
      editReviewerGroup(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Updated',
              description: 'Reviewer details updated.'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    } else {
      saveReviewerGroup(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Added',
              description: 'Reviewer added successfully.'
            });
            setSubmitLoading(false);
            setAddDrawerVisible(false);
            setSelectedItem(null);
            fetchAll();
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    }
  };
  const reInvite = id => {
    reInviteUser(id)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const disableUser = id => {
    disableOrEnableUser(id)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
          fetchAll();
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onChangeHandler = value => {
    setSearchString(value);
    setCurrentPage(0);
  };
  const debounceOnChange = useCallback(
    useDebounce(onChangeHandler, SEARCH_DELAY),
    []
  );

  const handleExport = () => {
    if (selectedTabKey === 'reviewer') {
      // Export reviewers
      let filteredData = reviewers;

      // Apply facility filter
      if (facilities && facilities.length > 0) {
        filteredData = filteredData.filter(reviewer =>
          reviewer.facilities.some(facility =>
            facilities.includes(facility.facilityId)
          )
        );
      }

      // Apply search filter
      if (searchString) {
        const searchLower = searchString.toLowerCase();
        filteredData = filteredData.filter(reviewer => {
          return (
            (reviewer.fullName && reviewer.fullName.toLowerCase().includes(searchLower)) ||
            (reviewer.email && reviewer.email.toLowerCase().includes(searchLower)) ||
            (reviewer.phoneNumber &&
              `${reviewer.phoneNumber.countryCode}${reviewer.phoneNumber.number}`.includes(searchLower))
          );
        });
      }

      // Custom export columns for reviewers
      const exportColumns = [
        { id: 'id', header: 'ID', accessorKey: 'id' },
        { id: 'fullName', header: 'Name', accessorKey: 'fullName' },
        { id: 'email', header: 'Email', accessorKey: 'email' },
        { id: 'phoneNumber', header: 'Phone Number', accessorKey: 'phoneNumber' },
        { id: 'facility', header: 'Facility', accessorKey: 'facilities' },
        { id: 'reviewerLevel', header: 'Reviewer Level', accessorKey: 'reviewerFlow' },
        { id: 'dictationType', header: 'Dictation Type', accessorKey: 'dictationType' },
        { id: 'createdAt', header: 'Created At', accessorKey: 'createdAt' }
      ];

      exportToExcel(filteredData, exportColumns, 'Reviewers');
    } else {
      // Export reviewer groups
      let filteredData = reviewersGroupList;

      // Apply search filter
      if (searchString) {
        const searchLower = searchString.toLowerCase();
        filteredData = filteredData.filter(group => {
          return (
            (group.groupName && group.groupName.toLowerCase().includes(searchLower)) ||
            (group.level && group.level.toLowerCase().includes(searchLower))
          );
        });
      }

      // Custom export columns for reviewer groups
      const exportColumns = [
        { id: 'id', header: 'ID', accessorKey: 'id' },
        { id: 'groupName', header: 'Group Name', accessorKey: 'groupName' },
        { id: 'reviewers', header: 'Reviewers', accessorKey: 'reviewers' },
        { id: 'level', header: 'Level', accessorKey: 'level' },
        { id: 'createdAt', header: 'Created At', accessorKey: 'createdAt' }
      ];

      exportToExcel(filteredData, exportColumns, 'ReviewerGroups');
    }
  };


  const getFacilities = () => {
    getUserFacilities()
      .then(response => {
        if (response.data.success) {
          setFacility(
            response.data.result.map(item => {
              return {
                label: item.facilityName,
                value: item.facilityId,
                disabled: item.disabled,
                className: item.disabled ? 'disabled-facility-option' : ''
              };
            })
          );
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    getFacilities();
  }, []);
  useEffect(() => {
    getReviewers()
      .then(response => {
        if (response.data.success) {
          // setTotal(response.data.size);
          setReviewersList(response.data.result);
        }
      })
      .catch(() => {
        // Reviewers list fetch error - don't affect main loading state
      });
  }, [reviewers]);
  return (
    <>
      <PageTitle title='Reviewers' />
      <ContainerRow gutter={[0, 40]}>
        <TitleRow justify='space-between'>
          <CustomTypography color={theme['@text-color']}>
            Reviewers
          </CustomTypography>
          <ControlsDiV>
            <AddButton
              icon={<PlusOutlined />}
              type='primary'
              onClick={() => setAddDrawerVisible(true)}
            >
              {selectedTabKey === 'reviewer' ? 'Add Reviewer' : 'Add Group'}
            </AddButton>
            <SearchInputStyle
              placeholder='Search'
              prefix={<SearchOutlined />}
              value={searchString}
              onChange={event => {
                setSearchString(event.target.value);
                debounceOnChange(event.target.value);
              }}
            />
            <AddButton
              icon={<DownloadOutlined />}
              onClick={handleExport}
            >
              Export to Excel
            </AddButton>
            <AddButton
              onClick={() => {
                setSearchString('');
                setClearFiltersTrigger(t => t + 1);
              }}
            >
              Clear Filter
            </AddButton>
            {/* <FacilityFilter setSelectedValues={setFacilities} /> */}
          </ControlsDiV>
        </TitleRow>

        <StyledListTab
          activeKey={selectedTabKey}
          onChange={key => {
            setSelectedTabKey(key);
          }}
        >
          <StyledJobListTabPane
            className='tab-pane'
            tab='Reviewer'
            key='reviewer'
          >
            <TanStackUserTable
              data={reviewers}
              columns={createReviewerColumns(
                setSelectedItem,
                setAddDrawerVisible,
                disableUser,
                reInvite,
                notClinicAdmin,
                false
              )}
              loading={loading}
              searchValue={searchString}
              storageKey='users_page_reviewers'
              clearFiltersTrigger={clearFiltersTrigger}
              customFilterFn={
                facilities && facilities.length > 0
                  ? reviewer => {
                      return reviewer.facilities.some(facility =>
                        facilities.includes(facility.facilityId)
                      );
                    }
                  : null
              }
            />
          </StyledJobListTabPane>
          <StyledJobListTabPane
            className='tab-pane'
            tab='Reviewer Group'
            key='reviewerGroup'
          >
            <TanStackUserTable
              data={reviewersGroupList}
              columns={createReviewerColumns(
                setSelectedItem,
                setAddDrawerVisible,
                disableUser,
                reInvite,
                notClinicAdmin,
                true
              )}
              loading={loading}
              searchValue={searchString}
              storageKey='users_page_reviewer_groups'
              clearFiltersTrigger={clearFiltersTrigger}
            />
          </StyledJobListTabPane>
        </StyledListTab>

        <CustomSideDrawer
          title={selectedItem ? 'Edit Reviewer' : 'Add Reviewer'}
          placement='right'
          closable={false}
          onClose={() => {
            setSelectedItem(null);
            setAddDrawerVisible(false);
          }}
          visible={addDrawerVisible}
          width={400}
          destroyOnClose={true}
        >
          {selectedTabKey === 'reviewer' ? (
            <AddReviewerForm
              facilities={facility}
              selectedItem={selectedItem}
              submitHandler={submitHandler}
              submitLoading={submitLoading}
            />
          ) : (
            <AddReviewerGroupForm
              reviewers={reviewersList}
              selectedItem={selectedItem}
              submitHandler={submitGroupHandler}
              submitLoading={submitLoading}
            />
          )}
        </CustomSideDrawer>
      </ContainerRow>
    </>
  );
}

export default Reviewers;
